/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CopilotTotalsByFeature extends models.CopilotActivityBase {
    getFixupPrototypeFunction() { return CopilotTotalsByFeature.fixupPrototype; }

    static newInstance(model: Partial<CopilotTotalsByFeature>): CopilotTotalsByFeature {
        let obj = Object.assign(new CopilotTotalsByFeature(), model);
        CopilotTotalsByFeature.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CopilotTotalsByFeature>): CopilotTotalsByFeature {
        if (!model) return null;
        return CopilotTotalsByFeature.newInstance(<CopilotTotalsByFeature> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CopilotTotalsByFeature) {
        if (!obj) return;

        models.CopilotTotalsByFeature.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CopilotTotalsByFeature): boolean {
        if (models.CopilotActivityBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, CopilotTotalsByFeature.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.user_initiated_interaction_count === undefined) {
            this.user_initiated_interaction_count = 0;
        }
    }

    /**
     * Feature name (e.g. code_completion)
     */
    feature: string;

    /**
     * Number of user initiated interactions
     */
    user_initiated_interaction_count: number;

}
